import { render, staticRenderFns } from "./PartnerCapitalReport.vue?vue&type=template&id=20a0d7f2&scoped=true"
import script from "./PartnerCapitalReport.vue?vue&type=script&lang=js"
export * from "./PartnerCapitalReport.vue?vue&type=script&lang=js"
import style0 from "./PartnerCapitalReport.vue?vue&type=style&index=0&id=20a0d7f2&prod&lang=css"
import style1 from "./PartnerCapitalReport.vue?vue&type=style&index=1&id=20a0d7f2&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "20a0d7f2",
  null
  
)

export default component.exports